export default function Check({size = 16, color = "#08875D"}) {
  const width = size * 3 / 4
  const height = size * 9 / 16
  
  return (
    <svg width={width} height={height} viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 4.33382L4.33333 7.66715L11 1.00049" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}
